import admin from "./admin";
import analytics from "./analytics";
import app from "./app";
import content from "./content";
import records from "./records";
import registration from "./registration";
import session from "./session";
import subscriptions from "./subscriptions";
const edge = {
    app,
    content,
    session,
    registration,
    records,
    analytics,
    admin,
    subscriptions,
};
export default edge;
